import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CommissionNote\CancelCommissionNoteController::__invoke
* @see app/Http/Controllers/CommissionNote/CancelCommissionNoteController.php
* @route '/api/commission-note/{commission_note}/cancel'
*/
const CancelCommissionNoteController = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CancelCommissionNoteController.url(args, options),
    method: 'post',
})

CancelCommissionNoteController.definition = {
    methods: ["post"],
    url: '/api/commission-note/{commission_note}/cancel',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CommissionNote\CancelCommissionNoteController::__invoke
* @see app/Http/Controllers/CommissionNote/CancelCommissionNoteController.php
* @route '/api/commission-note/{commission_note}/cancel'
*/
CancelCommissionNoteController.url = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { commission_note: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { commission_note: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            commission_note: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        commission_note: typeof args.commission_note === 'object'
        ? args.commission_note.id
        : args.commission_note,
    }

    return CancelCommissionNoteController.definition.url
            .replace('{commission_note}', parsedArgs.commission_note.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CommissionNote\CancelCommissionNoteController::__invoke
* @see app/Http/Controllers/CommissionNote/CancelCommissionNoteController.php
* @route '/api/commission-note/{commission_note}/cancel'
*/
CancelCommissionNoteController.post = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CancelCommissionNoteController.url(args, options),
    method: 'post',
})

export default CancelCommissionNoteController